import { OrderHistory } from '@/common/model/master/orderHistory'

export const OrderHistoryApiPath = {
  LIST_ORDER_HISTORY: '/api/sites/{site_id}/order-history', // GET List Order History
  BULK_CREATE_ORDER_HISTORY: '/api/sites/{site_id}/order-history/bulk', // POST Bulk Create Order History
  DELETE_ORDER_HISTORY: '/api/sites/{site_id}/order-history/{order_id}', // DELETE Delete Order History
  ORDER_ITEM_RANKINGS: '/api/sites/{site_id}/order-item-rankings', // GET Order Item Rankings
  ORDER_ITEM_RANKINGS_ANALYSIS: '/api/sites/{site_id}/order-item-rankings/analysis' // POST Order Item Rankings Analysis
}

export type OrderHistoryApiPath = (typeof OrderHistoryApiPath)[keyof typeof OrderHistoryApiPath]

export interface ListOrderHistoryVars {
  site_id: number
  page?: number
  per_page?: number
  search?: string
  s_order_datetime?: string
  s_customer_id?: string
  s_order_number?: string
  s_item_id?: string
}

export interface BulkCreateOrderHistoryVars {
  site_id: number
  orders: Record<string, unknown>[]
}

export interface DeleteOrderHistoryVars {
  site_id: number
  order_id: number
}

export interface OrderItemRankingsVars {
  site_id: number
  period?: string
  limit?: number
  periods?: number
}

export interface OrderItemRankingsAnalysisVars {
  site_id: number
  rankings: unknown[]
  period_type?: string
}

export interface ListOrderHistoryResponse {
  total: number
  page: number
  per_page: number
  orders: OrderHistory[]
}

export interface BulkCreateOrderHistoryResponse {
  created: number
  errors: { row: number; message: string }[]
}

export interface DeleteOrderHistoryResponse {
  deleted: boolean
}

export interface OrderItemRankingItem {
  rank: number
  item_id: string
  total_qty: number
  order_count: number
  total_amount: number
  rank_change: number | null
}

export interface OrderItemRankingPeriod {
  period_label: string
  period_start: string
  period_end: string
  items: OrderItemRankingItem[]
}

export interface OrderItemRankingsResponse {
  period_type: string
  rankings: OrderItemRankingPeriod[]
}

export interface OrderItemRankingsAnalysisResponse {
  analysis: string
}
